// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"rbEmjs-TE7aIsXtSOl5HG"};